import { render, staticRenderFns } from "./test1.vue?vue&type=template&id=078dd700&"
import script from "./test1.vue?vue&type=script&lang=js&"
export * from "./test1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports